import { plainToClassFromExist } from "class-transformer";
import { ResponseModel } from "@/models/classes/response";
import { CallToActionDataModel } from "@/models/classes/plan/visit/call_to_action";
import { CallToActionApi } from "@/services/api/plan/visit/call_to_action";

const api = new CallToActionApi();

export class CallToActionService {
  fetchGetCallToAction = async (params: any = {}) => {
    const resData = await api.getCallToAction(params);
    const resModel = plainToClassFromExist(
      new ResponseModel<CallToActionDataModel>(CallToActionDataModel),
      resData,
    );
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return { data: resModel.data, total: resModel.total ?? 0 };
    }
    return undefined;
  };

  fetchGetStockByCustomer = async (params: any = {}) => {
    const resData = await api.getStockByCustomer(params);
    const resModel = plainToClassFromExist(
      new ResponseModel<any>(Object),
      resData,
    );
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return { data: resModel.data, total: resModel.total ?? 0 };
    }
    return undefined;
  };

  saveCallToActionSuccess = async (data: any) => {
    const resData = await api.saveCallToActionSuccess(data);
    const resModel = plainToClassFromExist(
      new ResponseModel<any>(Object),
      resData,
    );
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return { data: resModel.data, total: resModel.total ?? 0 };
    }
    return undefined;
  };
}
